import { useController, useFormContext, useFieldArray } from 'react-hook-form';
import { UncontrolledInput } from 'components/Form';
import { defaultDetail } from './VenueDetail';
import { useEffect, useCallback } from 'react';
import { Button } from '@ontruck/orc';

const VenueContactElement = ({ contact, fieldName, error, onDeleteClick }) => {
  const { field: nameField } = useController({
    name: `${fieldName}.name`,
    defaultValue: contact.name,
    shouldUnregister: false,
    rules: {
      required: 'Name required',
    },
  });

  const { field: commentsField } = useController({
    name: `${fieldName}.comments`,
    defaultValue: contact.comments,
    shouldUnregister: false,
  });

  const { field: emailField } = useController({
    name: `${fieldName}.email`,
    defaultValue: contact.email,
    shouldUnregister: false,
  });

  const { field: phoneField } = useController({
    name: `${fieldName}.phone`,
    defaultValue: contact.phone,
    shouldUnregister: false,
    rules: {
      required: 'Phone required',
    },
  });

  return (
    <div className="contacts-edition-element">
      <div>
        <div className="half-fields">
          <div>
            <UncontrolledInput
              type="text"
              placeholder="Name"
              hasError={!!error?.name?.message}
              {...nameField}
            />
            {!!error?.name?.message && <div className="field-error">{error?.name?.message}</div>}
          </div>
          <div>
            <UncontrolledInput
              type="text"
              placeholder="Comments"
              hasError={!!error?.comments?.message}
              {...commentsField}
            />
            {!!error?.comments?.message && (
              <div className="field-error">{error?.comments?.message}</div>
            )}
          </div>
        </div>
        <div className="half-fields">
          <div>
            <UncontrolledInput
              type="text"
              placeholder="Email"
              hasError={!!error?.email?.message}
              {...nameField}
              {...emailField}
            />
            {!!error?.email?.message && <div className="field-error">{error?.email?.message}</div>}
          </div>
          <div>
            <UncontrolledInput
              type="text"
              placeholder="Phone"
              hasError={!!error?.phone?.message}
              {...phoneField}
            />
            {!!error?.phone?.message && <div className="field-error">{error?.phone?.message}</div>}
          </div>
        </div>
      </div>
      <div>
        <Button icon="trash" size="XS" iconPosition="left" skin="primary" onClick={onDeleteClick} />
      </div>
    </div>
  );
};

const VenueContactsEdit = ({ contacts, fieldName, error }) => {
  const { setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: fieldName,
    shouldUnregister: false,
  });

  const handleAdd = useCallback(() => {
    append();
  }, [append]);

  useEffect(() => {
    if (!contacts) {
      return;
    }
    setValue(fieldName, contacts);
    //eslint-disable-next-line
  }, [fieldName]);

  return (
    <>
      {fields.map((field, index) => (
        <VenueContactElement
          key={field.id}
          contact={field}
          fieldName={`${fieldName}.${index}`}
          error={(error || [])[index]}
          onDeleteClick={() => remove(index)}
        />
      ))}
      <div>
        <Button text="Add contact" nude onClick={handleAdd} icon="plus" iconPosition="left" />
      </div>
    </>
  );
};

const VenueContactsRenderer = ({ value: contacts, fieldName, isEditing, error }) => {
  if (isEditing) {
    return <VenueContactsEdit fieldName={fieldName} contacts={contacts} error={error} />;
  }

  if (!contacts?.length) {
    return <>{defaultDetail}</>;
  }

  return (
    <div>
      {contacts.map((contact) => (
        <div key={contact.name} className="venue-contact">
          <div>
            {contact.name} {!!contact.comments && <>({contact.comments})</>}
          </div>
          <div>
            {!!contact.phone && (
              <a href={`callto:${contact.phone}`} className="link">
                {contact.phone}
              </a>
            )}{' '}
            {!!contact.email && (
              <a href={`mailto:${contact.email}`} className="link">
                {contact.email}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VenueContactsRenderer;
